import { generateDynamicThemeToken } from '../../ThemeProvider';
import { getDynamicThemeToken } from './theme';
import { randomStr } from '../../Shared';
const componentName = 'Tag';
const classPrefix = `ui-Tag`;
export const tagClasses = {
    root: `${classPrefix}-root-${randomStr()}`,
    label: `${classPrefix}-label`,
    disabled: `${classPrefix}-disabled`,
    error: `${classPrefix}-error`,
    deleteIcon: `${classPrefix}-deleteIcon`,
    clickable: `${classPrefix}-clickable`,
    avatar: `${classPrefix}-avatar`,
};
export function getStyle(theme) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    const style = {
        [`&.${tagClasses.root}`]: {
            padding: tk(token.padding.root),
            borderRadius: tk(token.borderRadius),
            background: tk(token.background.default),
            height: 'auto',
            maxWidth: 'auto',
            cursor: 'auto',
            transition: 'none',
            '&:focus-visible': {
                outline: tk(token.outline),
                outlineOffset: '2px',
            },
            '& > *:not(:last-child)': {
                marginInlineEnd: tk(token.gap),
            },
            '&:active': {
                boxShadow: 'none',
            },
            [`&.${tagClasses.clickable}`]: {
                cursor: 'pointer',
                '&:hover': {
                    background: tk(token.background.hover),
                },
                '&:active': {
                    background: tk(token.background.active),
                    [`&:has(.${tagClasses.deleteIcon}:active)`]: {
                        background: tk(token.background.hover),
                    },
                },
            },
            [`.${tagClasses.deleteIcon}:focus-visible`]: {
                outline: tk(token.outline),
            },
            [`.${tagClasses.label}`]: {
                fontFamily: tk(token.fontFamily),
                fontSize: tk(token.fontSize),
                lineHeight: tk(token.lineHeight),
                color: tk(token.color.default),
                padding: 0,
            },
            [`& .${tagClasses.deleteIcon}`]: {
                color: tk(token.color.default),
                fontSize: tk(token.closeIconSize),
                lineHeight: 0,
                padding: tk(token.padding.deleteIcon),
                borderRadius: '2px',
                margin: tk(token.margin.deleteIcon),
                transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                '&:hover': {
                    background: tk(token.background.hover),
                },
                '&:active': {
                    background: tk(token.background.active),
                },
            },
            [`&.${tagClasses.disabled}`]: {
                opacity: 1,
                background: tk(token.background.disabled),
                [`& .${tagClasses.label}, .${tagClasses.deleteIcon}`]: {
                    color: tk(token.color.disabled),
                },
            },
            [`&.${tagClasses.error}`]: {
                boxShadow: tk(token.boxShadow.error),
                [`& .${tagClasses.label}, .${tagClasses.deleteIcon}`]: {
                    color: tk(token.color.error),
                },
            },
            [`&.${tagClasses.disabled}.${tagClasses.error}`]: {
                boxShadow: tk(token.boxShadow.errorDisabled),
                [`& .${tagClasses.label}, .${tagClasses.deleteIcon}`]: {
                    color: tk(token.color.errorDisabled),
                },
            },
            [`.${tagClasses.avatar}`]: {
                marginInlineStart: 0,
            },
        },
    };
    return style;
}
